import { jsx as a, jsxs as p } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { isEmpty as i } from "es-toolkit/compat";
import u from "../../../../utils/classNames.js";
import N from "../../../../components/applicationHeader/ApplicationActionBar.js";
const H = d(
  (r, n) => {
    const {
      homeRoute: t = "",
      appNavigator: v,
      appNavigatorClassName: f,
      appMenuItems: g,
      navItems: e = [],
      actionBarItems: l = [],
      onMount: h = () => {
      },
      onUnmount: k = () => {
      },
      className: o = "",
      ...m
    } = r, c = u(
      "ApplicationHeader VolkswagenApplicationHeader",
      "user-select-none",
      o && o
    );
    return /* @__PURE__ */ a("nav", { ...m, className: c, ref: n, children: /* @__PURE__ */ p("div", { className: "width-100pct", children: [
      /* @__PURE__ */ a("div", { className: "brand", children: /* @__PURE__ */ a("div", { className: "logo", children: t }) }),
      i(e) && /* @__PURE__ */ a("ul", { className: "SubmoduleNavigation nav" }),
      !i(e) && /* @__PURE__ */ a("ul", { className: "SubmoduleNavigation nav", children: e.map((s) => /* @__PURE__ */ a("li", { className: "submodule", "data-nav-item-key": s.key, children: s.route }, s.key)) }),
      /* @__PURE__ */ a(N, { items: l })
    ] }) });
  }
);
export {
  H as VolkswagenApplicationHeader,
  H as default
};
//# sourceMappingURL=VolkswagenApplicationHeader.js.map
